import { render, staticRenderFns } from "./login.logo.vue?vue&type=template&id=3ec79c6a&"
import script from "./login.logo.vue?vue&type=script&lang=js&"
export * from "./login.logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports